import React, { ReactNode } from 'react'

import { ExpenseTypeEligibility } from 'core/domain/expenses/expenseTypeEligibility'

interface DocumentationForExpenseProps {
  eligibility: ExpenseTypeEligibility
  companyName: string
  translate: (key: string) => string
}

const DocumentationForExpense: React.FC<DocumentationForExpenseProps> = ({ eligibility, companyName, translate }) => {
  const addInfo = <h6 className="add_info">{translate('get-reimburse.request.needs-to-verify-expense-description')}</h6>

  const getReimbursableContent = (
    <>
      {addInfo}
      <span className="add_info_item mb-8 block">{translate('get-reimburse.request.reimbursable-add-info')}</span>
      <ol className="add_info_item add_info_item_list">
        <li>{translate('get-reimburse.request.add-info-date-of-service')}</li>
        <li>{translate('get-reimburse.request.add-info-cost')}</li>
        <li>{translate('get-reimburse.request.add-info-item')}</li>
      </ol>
    </>
  )

  const getReimbursableWithEobContent = (companyName: string) => (
    <>
      {addInfo}
      <span className="add_info_item mb-8 block">
        {translate('get-reimburse.request.reimbursable-with-eob-add-info').replace('[COMPANY_NAME]', companyName)}
      </span>
      <ol className="add_info_item add_info_item_list">
        <li>{translate('get-reimburse.request.add-info-date-of-service')}</li>
        <li>{translate('get-reimburse.request.add-info-cost')}</li>
        <li>{translate('get-reimburse.request.add-info-item')}</li>
      </ol>
    </>
  )

  const getReimbursableWithPrescriptionContent = (
    <>
      {addInfo}
      <span className="add_info_item mb-8 block">
        {translate('get-reimburse.request.reimbursable-with-prescription-add-info')}
      </span>
      <ol className="add_info_item add_info_item_list">
        <li>{translate('get-reimburse.request.add-info-date-of-service')}</li>
        <li>{translate('get-reimburse.request.add-info-cost')}</li>
        <li>{translate('get-reimburse.request.add-info-item')}</li>
      </ol>
    </>
  )

  const getReimbursableWithDoctorsNoteContent = (
    <>
      {addInfo}
      <span className="add_info_item mb-8 block">
        {translate('get-reimburse.request.reimbursable-with-doctors-note-add-info')}
      </span>
      <ol className="add_info_item add_info_item_list">
        <li>{translate('get-reimburse.request.add-info-prescribed-item')}</li>
        <li>{translate('get-reimburse.request.add-info-specific-medical-condition')}</li>
      </ol>
      <span className="add_info_item mt-8">
        {translate('get-reimburse.request.reimbursable-with-doctors-note-add-info-1')}
      </span>
      <ol className="add_info_item add_info_item_list">
        <li>{translate('get-reimburse.request.add-info-date-of-service')}</li>
        <li>{translate('get-reimburse.request.add-info-cost')}</li>
        <li>{translate('get-reimburse.request.add-info-item')}</li>
      </ol>
    </>
  )

  const getContentBasedOnEligibility = (): ReactNode => {
    switch (eligibility) {
      case ExpenseTypeEligibility.Reimbursable:
        return getReimbursableContent
      case ExpenseTypeEligibility.ReimbursableWithEob:
        return getReimbursableWithEobContent(companyName)
      case ExpenseTypeEligibility.ReimbursableWithPrescription:
        return getReimbursableWithPrescriptionContent
      case ExpenseTypeEligibility.ReimbursableWithDoctorsNote:
        return getReimbursableWithDoctorsNoteContent
      case ExpenseTypeEligibility.NotReimbursable:
        return null
    }
  }

  return <>{getContentBasedOnEligibility()}</>
}

export default DocumentationForExpense
